const state = {
    user: {}
};

const getters = {
    user: state => state.user,

    isInHouseTechnician: state => state.user.role.tag === 'technician' && state.user.technician.in_house,
    isSuperAdmin: state => state.user.role.tag === 'superAdmin',
    isTechnician: state => state.user.role.tag === 'technician',
};

const actions = {
    fetchUser({commit}, {email, password}) {
        return new Promise((resolve, reject) => {
            this.$axios.get(`/api/login/${email}/${password}`)
                .then(response => {

                    let user = response.data.data;

                    if (user.company.name !== 'Reviveaphone') {
                        reject('You are not authorised to use this app.');
                    }

                    commit('SET_USER', user);
                    resolve();
                })
                .catch(errors => {
                    console.log(errors);
                    reject(errors.response.data.messages[0]);
                });
        });
    },

    clearUser({commit}) {
        return new Promise((resolve) => {
            commit('CLEAR_USER');
            resolve();
        })
    }
};

const mutations = {
    SET_USER(state, user) {
        state.user = user;
    },

    CLEAR_USER(state) {
        state.user = {};
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}